import React, { createContext, useContext, useState, ReactNode } from 'react';

interface LanguageContextType {
  currentLanguage: string;
  setCurrentLanguage: (lang: string) => void;
  multiLanguageData: Record<string, any>;
  setMultiLanguageData: (data: Record<string, any>) => void;
  updateFieldForLanguage: (language: string, field: string, value: any) => void;
  clearMultiLanguageData: () => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('de');
  const [multiLanguageData, setMultiLanguageData] = useState<Record<string, any>>({});

  const updateFieldForLanguage = (language: string, field: string, value: any) => {
    setMultiLanguageData((prev) => ({
      ...prev,
      [language]: {
        ...(prev[language] || {}),
        [field]: value,
      },
    }));
  };

  const clearMultiLanguageData = () => {
    setMultiLanguageData({});
  };

  return (
    <LanguageContext.Provider
      value={{
        currentLanguage,
        setCurrentLanguage,
        multiLanguageData,
        setMultiLanguageData,
        updateFieldForLanguage,
        clearMultiLanguageData,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
